import Portfolio from '../views/Portfolio';
import PortfolioProperty from '../views/PortfolioProperty';
import PortfolioPropertyNotes from '../views/PortfolioPropertyNotes';
import PortfolioPropertyPay from '../views/PortfolioPropertyPay';
import PortfolioPropertyWorksOrders from '../views/PortfolioPropertyWorksOrders';
import PortfolioPropertyWrapper from '../views/PortfolioPropertyWrapper';
import Statements from '../views/Statements';
import StatementsWrapper from '../views/StatementsWrapper';
import Transactions from '../views/Transactions';
import Invoices from "../views/Invoices.vue";

export default [
    {
        path: '/portfolio',
        name: 'portfolio',
        component: Portfolio,
        meta: {
            title: 'Portfolio',
        },
    },
    {
        path: '/portfolio/:id',
        component: PortfolioPropertyWrapper,
        meta: {
            title: 'Property',
        },
        pathToRegexpOptions: {
            strict: true,
        },
        children: [
            {
                path: '',
                name: 'portfolio-property',
                component: PortfolioProperty,
                pathToRegexpOptions: {
                    strict: false,
                },
            },
            {
                path: 'documents',
                name: 'portfolio-property-notes',
                component: PortfolioPropertyNotes,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.owners.documents) {
                        return next({
                            name: 'portfolio-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'works-orders',
                name: 'portfolio-property-works-orders',
                component: PortfolioPropertyWorksOrders,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.owners.works_orders) {
                        return next({
                            name: 'portfolio-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'pay',
                name: 'portfolio-property-pay',
                component: PortfolioPropertyPay,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.owners.online_payments && ! window.meta.features.owners.bank_account) {
                        return next({
                            name: 'portfolio-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
        ],
    },
    {
        path: '/accounts',
        component: StatementsWrapper,
        meta: {
            title: 'Accounts',
        },
        children: [
            {
                path: '',
                name: 'accounts',
                component: Statements,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.owners.statements) {
                        return next({
                            name: 'portfolio',
                        });
                    }
                    return next();
                },
            },
            {
                path: 'transactions',
                name: 'transactions',
                component: Transactions,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.owners.transactions) {
                        return next({
                            name: 'accounts',
                        });
                    }
                    return next();
                },
            },
            {
                path: 'invoices',
                name: 'invoices',
                component: Invoices,
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.owners.invoices) {
                        return next({
                            name: 'accounts',
                        });
                    }
                    return next();
                },
            },
        ],
    },
];
